/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RefundStatus {
  SUCCEEDED = 'succeeded',
  PENDING = 'pending',
}
